<template>
  <b-container class="dspbody">
    <b-row class="mb-5 body">
      <b-col cols="12" lg="12" class="dspBox_padding">
        <img src="../assets/img/Demjan.jpg" style="max-width: 100%;" />
      </b-col>

      <!-- DEMJÁN SÁNDOR TŐKEPROGRAM -->
      <b-col style="text-align:justify" cols="12" lg="12">
        <b-row>
          <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
            <button v-b-toggle="'accordion-1'" class="dspbuttonScroll">
              <b-col cols="12" lg="10"><span class="dspname">DEMJÁN SÁNDOR</span> TŐKEPROGRAM</b-col>
              <span v-if="!isOpenAccordion1">
                <ChevronRightIcon :size="30" />
              </span>
              <span v-if="isOpenAccordion1">
                <ChevronDownIcon :size="30" />
              </span>
            </button>
          </b-card-header>
        </b-row>
        <b-row>
          <b-collapse id="accordion-1" v-model="isOpenAccordion1">
            <div class="offer-description mt-2">
              <b-row class="dspblockBox">
                <b-col class="m-2">
                  <competition-small-details :competition="offer" />
                  <p>
                    A vállalkozások komolyabb mértékű, méretugrásukat támogató fejlesztéseinek speciális támogatása
                    keretében az állam 1%-os, jelképes tulajdonrész szerzése mellett biztosít 6 éves időtartamra olcsó,
                    nagyösszegű fejlesztési forrást alárendelt kölcsöntőke juttatás keretében.
                  </p>
                  <p>
                    A lehetőség iparági megkötöttség és széles körű beruházási célra biztosít viszonylag nagy összegű,
                    100-200 millió forintos friss forrást évi 5%-os kamatozás mellett. A tőkefinanszírozás révén a
                    vállalkozás hitelképessége javul.
                  </p>
                  <button class="dsplink" @click="openLink('https://mkik.hu/tokeprogram')" target="_blank">
                    Tovább a programra
                  </button>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </b-row>
      </b-col>

      <!-- DEMJÁN SÁNDOR 1+1 BERUHÁZÁS-ÉLÉNKÍTŐ TÁMOGATÁSI PROGRAM -->
      <b-col style="text-align:justify" cols="12" lg="12">
        <b-row>
          <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
            <button v-b-toggle="'accordion-2'" class="dspbuttonScroll">
              <b-col cols="12" lg="10">
                <span class="dspname">DEMJÁN SÁNDOR</span> „1+1” KKV BERUHÁZÁS-ÉLÉNKÍTŐ TÁMOGATÁSI PROGRAM
              </b-col>
              <span v-if="!isOpenAccordion2">
                <ChevronRightIcon :size="30" />
              </span>
              <span v-if="isOpenAccordion2">
                <ChevronDownIcon :size="30" />
              </span>
            </button>
          </b-card-header>
        </b-row>
        <b-row>
          <b-collapse id="accordion-2" v-model="isOpenAccordion2">
            <div class="offer-description mt-2">
              <b-row class="dspblockBox">
                <b-col class="m-2">
                  <competition-small-details :competition="offer" />
                  <p>
                    A program a hazai tulajdonú, mikro-, kis- és középvállalkozások eszközberuházásait támogatja annak
                    érdekében, hogy termelési kapacitásuk fejlődjön, magasabb hozzáadott értékű termékek gyártására
                    nyíljon lehetőség. Egy vállalkozás maximum 200 millió forint támogatásban részesülhet. A vállalkozás
                    beruházásának 50%-át az állam vissza nem térítendő támogatásként biztosítja.
                  </p>
                  <p>
                    A program elsődlegesen eszközbeszerzést támogat, emellett digitalizációs és megújuló energiával
                    kapcsolatos fejlesztések is finanszírozhatóak.
                  </p>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </b-row>
      </b-col>

      <!-- DEMJÁN SÁNDOR MINDEN VÁLLALKOZÁSNAK LEGYEN SAJÁT HONLAPJA PROGRAM -->
      <b-col style="text-align:justify" cols="12" lg="12">
        <b-row>
          <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
            <button v-b-toggle="'accordion-3'" class="dspbuttonScroll">
              <b-col cols="12" lg="10">
                <span class="dspname">DEMJÁN SÁNDOR</span> „MINDEN VÁLLALKOZÁSNAK LEGYEN SAJÁT HONLAPJA” PROGRAM
              </b-col>
              <span v-if="!isOpenAccordion3">
                <ChevronRightIcon :size="30" />
              </span>
              <span v-if="isOpenAccordion3">
                <ChevronDownIcon :size="30" />
              </span>
            </button>
          </b-card-header>
        </b-row>
        <b-row>
          <b-collapse id="accordion-3" v-model="isOpenAccordion3">
            <div class="offer-description mt-2">
              <b-row class="dspblockBox">
                <b-col class="m-2">
                  <competition-small-details :competition="offer" />
                  <p>
                    A program célja csökkenteni a hazai kkv-k digitalizációs elmaradását az uniós versenytársakhoz
                    képest – hazánkban a 10 fő feletti vállalkozások kétharmada rendelkezik saját honlappal, az európai
                    közel 80%-os átlagához képest – aki ma nincs jelen az interneten, vagy a social média felületein,
                    sokkal kisebb eséllyel talál magának ügyfelet.
                  </p>
                  <p>
                    A program keretében a kormány két éves időtartamra átvállalja az internetes megjelenés támogatásához
                    szükséges digitális eszközök (webcím, tárhely, email) szolgáltatói költségeit, támogatást nyújt a
                    weboldal és a social média felületek arculati és tartalomfejlesztéshez, a kibervédelmi, illetve az
                    internetes értékesítést támogató szolgáltatások igénybevételéhez.
                  </p>
                  <button class="dsplink" @click="openLink('https://palyazat.neum.hu')" target="_blank">
                    Tovább a programra
                  </button>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </b-row>
      </b-col>

      <!-- DEMJÁN SÁNDOR SZÉCHENYI KÁRTYA PROGRAM -->
      <b-col style="text-align:justify" cols="12" lg="12">
        <b-row>
          <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
            <button v-b-toggle="'accordion-4'" class="dspbuttonScroll">
              <b-col cols="12" lg="10">
                <span class="dspname">DEMJÁN SÁNDOR</span> KEDVEZMÉNYES (3,5%) SZECHENYI KÁRTYA
              </b-col>
              <span v-if="!isOpenAccordion4">
                <ChevronRightIcon :size="30" />
              </span>
              <span v-if="isOpenAccordion4">
                <ChevronDownIcon :size="30" />
              </span>
            </button>
          </b-card-header>
        </b-row>
        <b-row>
          <b-collapse id="accordion-4" v-model="isOpenAccordion4">
            <div class="offer-description mt-2">
              <b-row class="dspblockBox">
                <b-col class="m-2">
                  <competition-small-details :competition="offer" />
                  <p>
                    A beruházások ösztönzése érdekében november 1-től 5 százalékról 3,5 százalékra csökken az ügyfelek
                    által fizetendő éves kamat a Széchenyi Kártya program beruházást támogató hitelelemeinél:
                  </p>
                  <ul>
                    <li>Széchenyi Beruházási Hitel MAX+,</li>
                    <li>Széchenyi Lízing MAX+,</li>
                    <li>Széchenyi Mikrohitel MAX+,</li>
                    <li>Agrár Széchenyi Beruházási Hitel MAX+.</li>
                  </ul>
                  <p>
                    A még kedvezményesebb kamatozás mellett a 2025. június 30-ig Széchenyi Kártya beruházási
                    hiteltermékeit igénylő vállalkozások számára az első évben díjmentesen nyújtja a hitelhez kötelezően
                    kapcsolt kezesség kezességvállalását a Garantiqa Hitelgarancia Zrt.
                  </p>
                  <button class="dsplink" @click="openLink('https://www.kavosz.hu')" target="_blank">
                    Tovább a programra
                  </button>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </b-row>
      </b-col>

      <!-- DEMJÁN SÁNDOR EXPORTÖSZTÖNZŐ HITELPROGRAM -->
      <b-col style="text-align:justify" cols="12" lg="12">
        <b-row>
          <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
            <button v-b-toggle="'accordion-5'" class="dspbuttonScroll">
              <b-col cols="12" lg="10"><span class="dspname">DEMJÁN SÁNDOR</span> EXPORTÖSZTÖNZŐ HITELPROGRAM</b-col>
              <span v-if="!isOpenAccordion5">
                <ChevronRightIcon :size="30" />
              </span>
              <span v-if="isOpenAccordion5">
                <ChevronDownIcon :size="30" />
              </span>
            </button>
          </b-card-header>
        </b-row>
        <b-row>
          <b-collapse id="accordion-5" v-model="isOpenAccordion5">
            <div class="offer-description mt-2">
              <b-row class="dspblockBox">
                <b-col class="m-2">
                  <competition-small-details :competition="offer" />
                  <p>
                    A Demján Sándor Program keretében az EXIM újraindítja korábbi nagysikerű termékeit, amelyeket
                    exportáló és nem exportáló vállalkozások is igénybe vehetnek beruházási, zöld beruházási és lízing
                    célokra.
                  </p>
                  <ul>
                    <span>Termékek:</span>
                    <li>EXIM Jövő Exportőrei Beruházási és Zöld Beruházási Hitel</li>
                    <li>EXIM Exportélénkítő Beruházási Hitel és Lízing</li>
                  </ul>
                  <button class="dsplink" @click="openLink('https://exim.hu/demjan-sandor-program/')" target="_blank">
                    Tovább a programra
                  </button>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </b-row>
      </b-col>

      <!-- DEMJÁN SÁNDOR KIFEKTETÉST TÁMOGATÓ HITEL- ÉS TŐKEPROGRAM -->
      <b-col style="text-align:justify" cols="12" lg="12">
        <b-row>
          <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
            <button v-b-toggle="'accordion-6'" class="dspbuttonScroll">
              <b-col cols="12" lg="10">
                <span class="dspname">DEMJÁN SÁNDOR</span> KIFEKTETÉST TÁMOGATÓ HITEL- ÉS TŐKEPROGRAM
              </b-col>
              <span v-if="!isOpenAccordion6">
                <ChevronRightIcon :size="30" />
              </span>
              <span v-if="isOpenAccordion6">
                <ChevronDownIcon :size="30" />
              </span>
            </button>
          </b-card-header>
        </b-row>
        <b-row>
          <b-collapse id="accordion-6" v-model="isOpenAccordion6">
            <div class="offer-description mt-2">
              <b-row class="dspblockBox">
                <b-col class="m-2">
                  <competition-small-details :competition="offer" />
                  <p>
                    A program keretében külpiaci beruházások, cégalapítások, cégfelvásárlások (kifektetés)
                    támogathatóak, amelyek új piacok szerzésével, terjeszkedéssel segítik a vállalkozások
                    versenyképességének növelését, a cég növekedési pályára állását, a bevételi források és kockázatok
                    diverzifikációját. Nem titkolt cél magyar multik, nemzeti bajnok vállalkozások kinevelése.
                  </p>
                  <p>
                    EXIM Kifektetési Hitel:
                    <button class="dsplink" @click="openLink('https://exim.hu/demjan-sandor-program/')" target="_blank">
                      Tovább a programra
                    </button>
                  </p>
                  <p>
                    Tőkebefektetés a határokon átívelő beruházásokért:
                    <button
                      class="dsplink"
                      @click="openLink('https://focusventures.hu/nemzetkozi-lehetosegek')"
                      target="_blank"
                    >
                      Tovább a programra
                    </button>
                  </p>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </b-row>
      </b-col>

      <!-- DEMJÁN SÁNDOR UNIÓS TÁMOGATÁSI PROGRAMOK -->
      <b-col style="text-align:justify" cols="12" lg="12">
        <b-row>
          <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
            <button v-b-toggle="'accordion-7'" class="dspbuttonScroll">
              <b-col cols="12" lg="10"><span class="dspname">DEMJÁN SÁNDOR</span> UNIÓS TÁMOGATÁSI PROGRAMOK</b-col>
              <span v-if="!isOpenAccordion7">
                <ChevronRightIcon :size="30" />
              </span>
              <span v-if="isOpenAccordion7">
                <ChevronDownIcon :size="30" />
              </span>
            </button>
          </b-card-header>
        </b-row>
        <b-row>
          <b-collapse id="accordion-7" v-model="isOpenAccordion7">
            <div class="offer-description mt-2">
              <b-row class="dspblockBox">
                <b-col class="m-2">
                  <competition-small-details :competition="offer" />
                  <p>
                    A magyarországi kkv-szektor számára 2025-ben 650 milliárd forintnyi uniós forrás kihelyezésére
                    nyílik lehetőség vissza nem térítendő támogatás, támogatott hitel, illetve ezek kombinációja révén.
                  </p>
                  <h5>Részletek hamarosan!</h5>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </b-row>
      </b-col>

      <!-- DEMJÁN SÁNDOR KKV ADMINISZTRÁCIÓS TERHEINEK CSÖKKENTÉSE -->
      <b-col style="text-align:justify" cols="12" lg="12">
        <b-row>
          <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
            <button v-b-toggle="'accordion-8'" class="dspbuttonScroll">
              <b-col cols="12" lg="10">
                <span class="dspname">DEMJÁN SÁNDOR</span> KKV ADMINISZTRÁCIÓS TERHEINEK CSÖKKENTÉSE
              </b-col>
              <span v-if="!isOpenAccordion8">
                <ChevronRightIcon :size="30" />
              </span>
              <span v-if="isOpenAccordion8">
                <ChevronDownIcon :size="30" />
              </span>
            </button>
          </b-card-header>
        </b-row>
        <b-row>
          <b-collapse id="accordion-8" v-model="isOpenAccordion8">
            <div class="offer-description mt-2">
              <b-row class="dspblockBox">
                <b-col class="m-2">
                  <competition-small-details :competition="offer" />
                  <p>
                    A Nemzetgazdasági Minisztérium a vállalkozói szakmai és érdekképviseleti szervezetekkel országszerte
                    és folyamatosan konzultálva felmérjük és összegyűjtjük a KKV-k javaslatait és igényeit az őket
                    terhelő adminisztráció csökkentésére, és működési környezetük egyszerűsítésére vonatkozóan.
                  </p>
                  <p>
                    Az adminisztrációcsökkentés kiemelt fókuszterületei:
                  </p>
                  <ul>
                    <li>adatszolgáltatás</li>
                    <li>jogszabályi környezet</li>
                    <li>adózási adminisztráció</li>
                  </ul>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </b-row>
      </b-col>

      <!-- DEMJÁN SÁNDOR MIKROVÁLLALKOZÁSOK ÁRAMÁRAINAK CSÖKKENTÉSE -->
      <b-col style="text-align:justify" cols="12" lg="12">
        <b-row>
          <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
            <button v-b-toggle="'accordion-9'" class="dspbuttonScroll">
              <b-col cols="12" lg="10">
                <span class="dspname">DEMJÁN SÁNDOR</span> MIKROVÁLLALKOZÁSOK ÁRAMÁRAINAK CSÖKKENTÉSE
              </b-col>
              <span v-if="!isOpenAccordion9">
                <ChevronRightIcon :size="30" />
              </span>
              <span v-if="isOpenAccordion9">
                <ChevronDownIcon :size="30" />
              </span>
            </button>
          </b-card-header>
        </b-row>
        <b-row>
          <b-collapse id="accordion-9" v-model="isOpenAccordion9">
            <div class="offer-description mt-2">
              <b-row class="dspblockBox">
                <b-col class="m-2">
                  <competition-small-details :competition="offer" />
                  <h4>Mikrovállalkozások áramárainak csökkentése</h4>
                  <p>
                    2025. január 1-jétől újabb mikrovállalkozások válnak jogosulttá a villamos energia egyetemes
                    szolgáltatás igénybevételére, akik 2022. június 18-án nem egyetemes szolgáltatótól vételeztek, vagy
                    ezen dátumot követően alakultak meg. Ennek köszönhetően számos további mikrovállalkozás kaphatja az
                    áramot az olcsóbb, rezsicsökkentett, azaz a nem lakossági egyetemes szolgáltatás árképzésének
                    megfelelő áron, a 4 606 kWh éves fogyasztásig.
                  </p>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'

export default {
  name: 'DemjanSandorProgram',
  components: {
    ChevronDownIcon,
    ChevronRightIcon
  },
  data() {
    return {
      isOpenAccordion1: false,
      isOpenAccordion2: false,
      isOpenAccordion3: false,
      isOpenAccordion4: false,
      isOpenAccordion5: false,
      isOpenAccordion6: false,
      isOpenAccordion7: false,
      isOpenAccordion8: false,
      isOpenAccordion9: false,
      offer: {} // Itt tárolhatod a versenyt
    }
  },
  methods: {
    openLink(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.dspbody {
  background: #4e8896;
  color: white;
}
.dspname {
  color: #bfe6e5;
}
.dsplink {
  background-color: #a27e5b;
  border-radius: 5px;
  color: white;
  font-family: Arial;
  border: none;
  cursor: pointer;
  height: 40px;
  width: auto;
}

.dspbuttonScroll {
  all: unset; /* Eltávolítja az alapértelmezett stílusokat */
  background-color: transparent; /* Alapértelmezett háttér eltávolítása */
  display: flex; /* Flexbox használata */
  align-items: center; /* Függőleges középre igazítás */
  justify-content: space-between; /* Kiegyenlíti a tartalmat a sor végére */
  width: 100%; /* A teljes szélességet kitölti */
  font-size: large;
  margin: 15px;
}

.dspbuttonScroll b-col {
  display: flex;
  align-items: center; /* Függőleges igazítás minden b-col elemnél */
}

.dspbox-Role {
  padding: 0; /* Eltávolítja a paddingot a card header-ből */
  border: none; /* Eltávolítja a szegélyeket, ha nem szükségesek */
  display: flex; /* Flexbox aktiválása a header-en belül */
  justify-content: space-between; /* Rendezi a gyermekelemeket egy sorba */
  align-items: center; /* Igazítja a tartalmat függőlegesen */
  width: 100%; /* A teljes szélességet kitölti */
  background: #4e8896;
}

.dspblockBox {
  margin: 20px;
}

.dspname,
.dsplink {
  margin: 0; /* Eltávolítja az alapértelmezett margókat */
}

.dspwhen-opened,
.dspwhen-closed {
  display: inline-block; /* Az ikonokat is sorba rendezi */
}

.dspbody {
  background: #4e8896;
  color: white;
}
.dspname {
  color: #bfe6e5;
}

::v-deep #simple-popup .modal-content {
  background-color: #f8f9fa;
  padding: 1rem;
}

::v-deep #simple-popup .modal-header {
  border-bottom: none;
  text-align: right;
}
.box-popup {
  border-radius: 20px;
  margin-top: 28%;
}
.notification-signature {
  font-weight: bold;
  text-align: right;
}
</style>
